import { useLayoutEffect } from 'react';

export function useWindowResize(callback, deps = []) {
  useLayoutEffect(() => {
    window.addEventListener('resize', callback);

    return () => window.removeEventListener('resize', callback);
  }, deps);
}